// src/utils/authUtils.ts (or similar)
import { User } from '@auth0/auth0-react'; // Import User type if needed

export interface AuthCapabilities {
  canChangeEmail: boolean;
  canChangePassword: boolean;
  canManageMfa: boolean;
  canManagePasskeys: boolean; // Added based on RN code
  connectionType: string;
  connection?: string;
}

export const getUserAuthCapabilities = (auth0User: User | undefined): AuthCapabilities => {
  console.log('getUserAuthCapabilities', auth0User);

  // Default values
  let canChangeEmail = false;
  let canChangePassword = false;
  let canManageMfa = false;
  let canManagePasskeys = false;
  let connectionType = 'unknown';
  let connectionName: string | undefined = undefined;

  // Auth0 user object structure might differ slightly in auth0-react
  // Often the connection info is in the 'sub' property or an identities array
  const sub = auth0User?.sub; // e.g., "auth0|12345", "email|12345", "google-oauth2|12345"

  if (sub) {
    if (sub.startsWith('auth0|')) {
      // Database connection (username/password)
      connectionType = 'username-password';
      canChangeEmail = true;
      canChangePassword = true;
      canManageMfa = true;
      canManagePasskeys = true; // Assuming passkeys are allowed for db connections
      connectionName = 'username-password'; // Or fetch specific connection if needed
    } else if (sub.startsWith('email|')) {
      // Passwordless email
      connectionType = 'passwordless-email';
      canChangeEmail = true; // Usually can change email if it's the primary factor
      canChangePassword = false;
      canManageMfa = true; // Can usually add MFA
      canManagePasskeys = false; // Typically no passkeys for passwordless
      connectionName = 'email';
    } else if (sub.startsWith('sms|')) {
      // Passwordless SMS
      connectionType = 'passwordless-sms';
      // Usually cannot change the bound phone number easily via app
      canChangeEmail = false;
      canChangePassword = false;
      canManageMfa = false;
      canManagePasskeys = false;
      connectionName = 'sms';
    } else if (sub.includes('|')) {
      // Social / Enterprise connection (SSO)
      connectionType = 'sso';
      canChangeEmail = false; // Managed by IdP
      canChangePassword = false; // Managed by IdP
      canManageMfa = false; // MFA usually managed by IdP or Auth0 rule, not direct enrollment
      canManagePasskeys = false;
      connectionName = sub.split('|')[0]; // e.g., 'google-oauth2'
    }
  }

  // You might need to inspect the full auth0User object for more details
  // if the 'sub' prefix isn't sufficient or if you use custom claims.
  // Example: Check user_metadata or app_metadata if you store connection info there.

  console.log('Auth Capabilities Determined:', {
    canChangeEmail,
    canChangePassword,
    canManageMfa,
    connectionType,
    connectionName,
  });

  return {
    canChangeEmail,
    canChangePassword,
    canManageMfa,
    canManagePasskeys, // Include this if your backend/Auth0 setup supports it
    connectionType,
    connection: connectionName,
  };
};
